export default function notEq(left: unknown, right: unknown) {
  return left !== right;
}
